// src/components/molecules/FilterButton/FilterButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip, Badge } from '@mui/material';
import { FilterList as FilterIcon } from '@mui/icons-material';
import {
  operationalRadii,
  operationalSizing,
  operationalSpacing
} from '../../../design-system/tokens';

/**
 * FilterButton - Componente molecular para botão de filtro
 *
 * CLASSIFICAÇÃO: MOLÉCULA
 *
 * Este componente combina múltiplos átomos: Button, Tooltip, Badge e Icon
 * para criar um botão de filtro funcional com contador de filtros ativos.
 *
 * @see https://bradfrost.com/blog/post/atomic-web-design/
 */
const FilterButton = ({
  onClick,
  active = false,
  activeFiltersCount = 0,
  tooltip = 'Filtrar',
  className = '',
  ...props
}) => {
  return (
    <Tooltip title={tooltip} arrow>
      <Badge
        badgeContent={activeFiltersCount}
        color="primary"
        invisible={activeFiltersCount === 0}
      >
        <Button
          variant={active ? 'contained' : 'outlined'}
          color={active ? 'primary' : 'inherit'}
          onClick={onClick}
          className={`filter-button ${className}`}
          sx={{
            // Usando Design Tokens para consistência
            minWidth: operationalSizing.compact,
            width: operationalSizing.compact,
            height: operationalSizing.compact,
            p: operationalSpacing.xs,
            borderRadius: `${operationalRadii.control}px`,
            ...props.sx
          }}
          {...props}
        >
          <FilterIcon sx={{ fontSize: '1.3rem' }} />
        </Button>
      </Badge>
    </Tooltip>
  );
};

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  activeFiltersCount: PropTypes.number,
  tooltip: PropTypes.string,
  className: PropTypes.string
};

export default FilterButton;
